import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, BookA, Shield, ClipboardCheck, Gauge } from 'lucide-react';
export function WhatYouGetSection() {
  const features = [{
    icon: <BookOpen className="w-8 h-8 text-amber-500" data-id="element-201" />,
    title: "Guía Digital CDL 'El Atajo'",
    desc: 'El sistema completo paso a paso para dominar Conocimiento General, Frenos de Aire y Combinación.'
  }, {
    icon: <BookA className="w-8 h-8 text-amber-500" data-id="element-202" />,
    title: 'Diccionario de Palabras Clave',
    desc: 'Los 50 términos en inglés que garantizan que entiendas la pregunta sin ser bilingüe.'
  }, {
    icon: <Shield className="w-8 h-8 text-amber-500" data-id="element-203" />,
    title: 'Protocolo de 7 Pasos (Frenos de Aire)',
    desc: 'El método exacto para no fallar la prueba más difícil del examen.'
  }, {
    icon: <ClipboardCheck className="w-8 h-8 text-amber-500" data-id="element-204" />,
    title: 'Checklist de Inspección Pre-Viaje',
    desc: "La 'Frase Mágica' que debes decirle al examinador para que sepa que eres un profesional."
  }, {
    icon: <Gauge className="w-8 h-8 text-amber-500" data-id="element-205" />,
    title: 'Simulador de Números Sagrados',
    desc: 'Tabla de memoria rápida para los PSI de presión que siempre vienen en el test.'
  }];
  return <section className="py-20 bg-slate-900 px-4 sm:px-6 lg:px-8" data-id="element-206">
      <div className="max-w-6xl mx-auto" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-208">
          <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white uppercase mb-4" data-id="element-209">
            Lo que <span className="text-amber-500" data-id="element-210">Obtienes Hoy</span>
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto rounded-full" data-id="element-211"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-212">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-slate-800 border border-slate-700 p-8 rounded-2xl hover:border-amber-500/50 transition-colors group ${index === 0 ? 'md:col-span-2 lg:col-span-3 lg:flex lg:items-center lg:gap-8' : ''}`} data-id="element-213">
              <div className={`bg-slate-900 p-4 rounded-xl inline-block mb-6 group-hover:scale-110 transition-transform ${index === 0 ? 'lg:mb-0 lg:flex-shrink-0' : ''}`} data-id="element-214">
                {feature.icon}
              </div>
              <div data-id="element-215">
                <h3 className="text-xl font-oswald font-bold text-white mb-3 uppercase tracking-wide" data-id="element-216">
                  {feature.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-217">{feature.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}